import { DateTime } from 'luxon';

const PRICE_TRANSFORM_VALUE = 100;

export const TIME_ZONE = 'America/New_York';

export const isBlackoutDate = (reservationDate, blackoutDates) => {
  return blackoutDates.includes(reservationDate);
};

export const isDateValid = (dateRange, reservationDate) => {
  const { startDate, endDate: rollerEndDate } = dateRange;

  // // update endDate to fix Roller bad config
  let endDate;

  if (rollerEndDate) {
    endDate = formatRollerDate(rollerEndDate);
  }

  if (
    startDate &&
    DateTime.fromISO(reservationDate) < DateTime.fromISO(startDate)
  ) {
    return false;
  }

  if (
    endDate &&
    DateTime.fromISO(reservationDate) > DateTime.fromISO(endDate)
  ) {
    return false;
  }

  return true;
};

export const isDayValid = (dateRange, reservationDate) => {
  const { days } = dateRange;

  const reservationDay = DateTime.fromISO(reservationDate).weekday % 7;

  // Support Sunday as both 0 and 7
  const normalizedReservationDays =
    reservationDay === 0 ? [0, 7] : [reservationDay];

  if (
    days?.length > 0 &&
    !normalizedReservationDays.some((day) => days.includes(day))
  ) {
    return false;
  }

  return true;
};

export const isProductIdValid = (productIdList, productId) => {
  // when a discount doesnt have a product id is valid for all
  if (!productIdList?.length) {
    return true;
  }

  return productIdList.some((val) => val === productId.toString());
};

export const formatRollerDate = (rollerDate) => {
  let date = new Date(rollerDate);
  date.setDate(date.getDate() + 1);
  date = date.toISOString();
  return date;
};

export const getDiscount = (price, percentOff, quantity = 1) => {
  const value = price * quantity;
  const discount = (percentOff / 100) * value;

  return discount;
};

export const validateDiscountMax = (discountVal, discountMax) => {
  const discountFormatted = discountVal / PRICE_TRANSFORM_VALUE;

  if (discountFormatted > discountMax) {
    // normalize to roller values
    return discountMax * PRICE_TRANSFORM_VALUE;
  }

  return discountVal;
};

export const getProductsQuantities = (cartItems) => {
  return cartItems
    .map((cartItem) => cartItem.quantities)
    .map((item) =>
      Object.keys(item).map((key) => ({ productId: key, quantity: item[key] }))
    )
    .flat();
};

export const keys = {
  DISCOUNT_CODE_KEY: '_discount_code',
  DISCOUNT_USAGE_KEY: '_discount_usage',
  DISCOUNT_VALUE_KEY: '_discount_value',
};

export const getValidDaysString = (dateRange) => {
  const days = {
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday',
    7: 'Sunday',
  };

  return dateRange.days.map((d) => days[d]);
};
